import { api } from 'src/utils/auth';
import { errorType } from 'src/interface/common';
import { env } from 'src/env';
const APIURL = env.REACT_APP_API_HOST;

/**
 Fetch : Member 목록
**/
export const fetchDefault = async (param: object, subUrl: string, Credentials?: boolean) => {
  const url = APIURL + subUrl;
  const config = {
    timeout: 10000,
    headers: {
      'Content-Type': 'application/json',
      Accept: '*/*',
      withCredentials: Credentials || false,
    },
  };
  try {
    const { data } = await api.post(url, param, config);
    return data;
  } catch (e) {
    return { error: e };
  }
};

/**
 Fetch : Member Auth
**/
export const fetchAuth = async (param: object, subUrl: string, timeout?: number) => {
  const sendUrl = APIURL + subUrl;
  try {
    const tokenType = 'Bearer';
    const accessToken = localStorage.getItem('accessToken');
    const config = {
      timeout: timeout || 10000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${tokenType} ${accessToken}`,
        withCredentials: false,
      },
    };
    const data = await api.post(sendUrl, param, config);

    return data.data;
  } catch (e) {
    return { error: e };
  }
};

/**
 Fetch : Member Auth
**/
export const fetchFormAuth = async (formData: any, url: string, timeout?: number) => {
  try {
    const sendUrl = APIURL + url;
    console.log('fetchFormAuth sendUrl', sendUrl);
    const tokenType = 'Bearer';
    const accessToken = localStorage.getItem('accessToken');

    const config = {
      timeout: timeout || 10000,
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `${tokenType} ${accessToken}`,
        withCredentials: false,
      },
      onUploadProgress: (progressEvent: any) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        console.log('Upload Progress:', percentCompleted, '%');
        // 여기서 progress 상태를 업데이트하거나 이벤트를 발생시킬 수 있음
      },
    };
    const retData = await api.post(sendUrl, formData, config);
    return retData;
  } catch (e) {
    return { error: e };
  }
};

/**
 Fetch : Member Auth
**/
export const fetchFormFileUploadAuth = async (formData: any, url: string, timeout?: number) => {
  return new Promise(resolve => {
    const sendUrl = APIURL + url;
    console.log('fetchFormAuth sendUrl', sendUrl);
    const tokenType = 'Bearer';
    const accessToken = localStorage.getItem('accessToken');

    const config = {
      timeout: timeout || 600000,
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `${tokenType} ${accessToken}`,
        withCredentials: false,
      },
      onUploadProgress: (progressEvent: any) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        console.log('Upload Progress:', percentCompleted, '%');

        // 파일 전송이 완료된 시점에 바로 resolve
        if (progressEvent.loaded === progressEvent.total) {
          console.log('File transfer completed');
          resolve({
            status: 'UPLOAD_COMPLETE',
            message: 'File transfer completed',
          });
        }
      },
    };

    // 요청 시작. 응답은 기다리지 않음
    api
      .post(sendUrl, formData, config)
      .then(() => {
        console.log('Server processing started');
      })
      .catch(e => {
        console.error('Server processing error:', e);
      });
  });
};

export const fetchAuthLocal = async (param: object, subUrl: string) => {
  try {
    return await api.post(APIURL + subUrl, param);
  } catch (error) {
    return { error };
  }
};

/**
 Fetch : 
**/
export const fetchForm = async (formData: any, url: string, timeout?: number) => {
  try {
    const sendUrl = APIURL + url;
    const config = {
      timeout: timeout || 100000,
      headers: {
        'Content-Type': 'multipart/form-data',
        withCredentials: false,
      },
      onUploadProgress: (progressEvent: any) => {
        console.log('Upload..');
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        console.log('Upload Progress:', percentCompleted, '%');
        // 여기서 progress 상태를 업데이트하거나 이벤트를 발생시킬 수 있음
      },
    };
    const retData = await api.post(sendUrl, formData, config);
    return retData;
  } catch (e) {
    return { error: e };
  }
};

export const setError = (data: any, error: any, errMsg?: string) => {
  const errorSet: errorType = {
    type: '',
    icon: '',
    mainTitle: '',
    subTitle: '',
    code: '',
  };
  const resData = data;
  if (resData) {
    if (resData?.status?.code + '' !== '200') {
      errorSet.type = 'error';
      errorSet.icon = 'ri-alert-line';

      errorSet.mainTitle = resData?.status?.message || '';
      errorSet.subTitle = resData?.status?.code || '';
      if (errMsg) {
        errorSet.mainTitle = errMsg;
        errorSet.subTitle = '';
      }

      const errStatus = resData?.error?.response?.data?.status || {};
      if (errStatus?.message || '' !== '') {
        errorSet.mainTitle = errStatus?.message;
        errorSet.subTitle = errStatus?.detail?.message || '';
      }
    }
  } else {
    errorSet.type = 'error';
    errorSet.icon = 'ri-alert-line';
    errorSet.mainTitle = data?.error?.message || '';
    errorSet.subTitle = data?.error?.code || '';
  }

  // if (error !== null) {
  //   errorSet.type = 'error';
  //   errorSet.mainTitle = error?.code || '';
  //   errorSet.subTitle = error.status + ' ' + error.message || '';
  // }
  return errorSet;
};
